import React from 'react';
import { useCookieConsent } from '../context/CookieConsentContext';
const CookieConsent = () => {
    const { cookieAccepted, handleAcceptCookies } = useCookieConsent();
  
  // Check if the user has already accepted cookies
  if(cookieAccepted) return null;


  return (
    <div className="cookie-wrapper">
      <div className="cookie-container">
        <div className="flex-one">
          <h2>About cookies on this site</h2>
          <p>
            In order to provide a more relevant experience for you, we use cookies to
            enable some website functionality. In addition, other cookies may be
            used with your consent to analyze site usage, improve the user
            experience, and provide many other site benefits.
          </p>
        </div>
        <div className="loging_buttom w-260" style={{ float: 'right' }}>
          <button onClick={handleAcceptCookies}>Accept All</button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
